const RAW_API_BASE =
  (process.env.REACT_APP_AUTH_API_BASE || "http://127.0.0.1:8000") + "/users";

const API_URL = RAW_API_BASE.replace(/\/$/, "");

export async function fetchUserDomainsFromAPI(userId) {
  if (!userId || userId <= 0) return [];
  
  try {
    const token = 
      localStorage.getItem('auth_token') ||  
      sessionStorage.getItem('auth_token');

    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Try primary endpoint /users/dominios-usuario
    const response = await fetch(`${API_URL}/dominios-usuario`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ id: userId }),
    });

    if (response.status === 401) {
      console.warn('[domainService] 401 Unauthorized token when calling /users/dominios-usuario.');
      window.dispatchEvent(new CustomEvent('session-expired'));
      return [];
    }

    if (response.status === 403) {
      console.warn('[domainService] 403 Forbidden: Se requiere rol especialista para consultar /users/dominios-usuario. Usando dominios en estado local.');
     window.dispatchEvent(new CustomEvent('unauthorized-domain'));
      return [];
    }

    if (response.ok) {
      const data = await response.json();
      if (data && data.success && Array.isArray(data.dominios)) {
        return data.dominios.map(d => d.dominio);
      }
    }
  } catch (err) {
    console.warn('[domainService] Error fetching user domains from API:', err);
  }

  return [];
}